import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import normalTable from "./plugin/normalTable.vue"
import adminTable from "./plugin/adminTable.vue"
import {
    domainName
} from "../../../utility/index"
export default {
    name: "FingerprintLibraryFile",
    components: {
        tree,
        iTable,
        IPagination,
        normalTable,
        adminTable
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                fingerGroupId: '',
                fingerGroupName: '',
                // totalCount: ''
            },
            height: '550',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [{
                prop: "fingerGroupId",
                label: this.$t('DriverManagement.teamNumber'),
                align: "center",
            },
            {
                prop: "fingerGroupName",
                label: this.$t('DriverManagement.teamName'),
                align: "center",

            },
            {
                prop: "orgName",
                label: this.$t('common.orgName'),
                align: "center",

            },
            {
                prop: "adminNum",
                label: this.$t('DriverManagement.adminNum'),
                align: "center",
            },
            {
                prop: "normalNum",
                label: this.$t('DriverManagement.normalNum'),
                align: "center",
            },
            {
                prop: "remark",
                label: this.$t('common.remark'),
                align: "center",

            }
            ],
            dialogOperateFormVisible: false,
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        isBtn: "FINGERPRINTLIBRARYFILE_DETAIL",
                        method: (index, row) => {
                            this.fingerGroupId = row.fingerGroupId
                            this.dialogOperateFormVisible = true
                            this.getNormalList()
                            this.getAdminList()
                        }
                    }
                ],
            },
            currentPage: 1,
            pageSize: 10, 
            total: 1, 
            dialogFormVisible: false,
            formLabelWidth: '100px',
            diaTitle: '',
            btnType: '',
            rules: {
                fingerGroupName:[ { required: true, message: this.$t('DriverManagement.form.choseFingerBankName'), trigger: 'change' }]
            },
            form: {
                fingerGroupName: '',
                normalList: '',
                adminList: '',
            },
            dialogVisibleAddDrivre: false,
            dialogVisibleAdminDrivre: false,
            dialogTransferFormVisible: false,
            LabelWidth: '118px',
            TransferRules: {},
            TransferForm: {
                fingerGroupId: '',
                roleId: ''
            },
            selected: [],
            id: '',
            name: '',
            normalList: [],
            adminList: [],
            authorizeHeight: '350px',
            authorizeOption: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: false, 
                serialNumber: true,
            },
            authorizeColumns: [
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",
                    width: "180px"
                },
                {
                    prop: "driverName",
                    label: this.$t('common.driverName'),
                    align: "center",
                },
                // {
                //     prop: "fingerNumV2",
                //     label: this.$t('DriverManagement.authorizes'),
                //     align: "center",

                // }
            ],
            authorizeOperates: {
                width: 100,
                fixed: "right",
                list: [
                    
                ],
            },
            fingerGroupId: ''
        }
    },
    created() {

    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getFingerprintLibraryList()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getFingerprintLibraryList()
        },
        getFingerprintLibraryList() {
            let param = {
                orgId: this.id,
                fingerGroupId: this.formInline.fingerGroupId,
                fingerGroupName: this.formInline.fingerGroupName,
                // totalCount: this.formInline.totalCount,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('DriverFingerprintFile/GET_FINGERPRINTLIBRARYLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getFingerprintLibraryList()
        },
        onClear() {
            this.formInline = {
                fingerGroupId: '',
                fingerGroupName: '',
                // totalCount: ''
            }
            this.getFingerprintLibraryList()
        },
        addTerminal() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('DriverManagement.addTeam')
            this.btnType = 'add'
            this.$nextTick(() => {
                this.$refs.form.resetFields()
                this.form.fingerGroupName = ''
                this.form.normalList = ''
                this.form.adminList = ''
            })

        },
        editTerminal() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('DriverManagement.editTeam')
            this.btnType = 'edit'
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
            })
            this.fingerGroupId = this.selected[0].fingerGroupId
            this.form.fingerGroupName = this.selected[0].fingerGroupName
            this.form.normalList = this.selected[0].normalList
            this.form.adminList = this.selected[0].adminList
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        orgId: this.id,
                        fingerGroupName: this.form.fingerGroupName,
                        normalList: this.form.normalList,
                        adminList: this.form.adminList,
                    }
                    if (this.btnType == 'add') {
                        this.$store.dispatch('DriverFingerprintFile/GET_INSERTFINGERPRINTLIBRARY', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('DriverManagement.btn.addFingerSuccess'))
                                this.dialogFormVisible = false;
                                this.getFingerprintLibraryList();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }


                        }).catch(err => { })

                    } else {
                        param.fingerGroupId = this.selected[0].fingerGroupId
                        this.$store.dispatch('DriverFingerprintFile/GET_UPDATEFINGERPRINTLIBRARY', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('DriverManagement.btn.editFingerSuccess'))
                                this.dialogFormVisible = false;
                                this.getFingerprintLibraryList();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }


                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                fingerGroupName: '',
                normalList: '',
                adminList: '',
            }
        },
        closeDia() {
            this.form = {
                fingerGroupName: '',
                normalList: '',
                adminList: '',
            }
            this.dialogFormVisible = false;
        },
        getNormalDriver() {
            if (this.btnType == 'add'){
                this.dialogVisibleAddDrivre = true
                this.$nextTick(() => {
                    this.$refs.normalTable.checkedTable = []
                    this.$refs.normalTable.orgId = this.id
                    this.$refs.normalTable.getDriver()
                    this.$refs.normalTable.$refs.multipleTable.clearSelection();
                    this.$refs.normalTable.$refs.multipleTable.toggleAllSelection();
                })
            } else {
                this.dialogVisibleAddDrivre = true
                this.$nextTick(() => {
                    this.$refs.normalTable.checkedTable = []
                    this.$refs.normalTable.orgId = this.id
                    this.$refs.normalTable.getDriver()
                    this.$refs.normalTable.getRightData()
                    this.$refs.normalTable.$refs.multipleTable.clearSelection();
                    this.$refs.normalTable.$refs.multipleTable.toggleAllSelection();
                })
            }
            
        },
        handleAddDrivreClose() {
            this.dialogVisibleAddDrivre = false
        },
        assignment() {
            this.form.normalList = this.checkList
            console.log(this.form.normalList)
            this.dialogVisibleAddDrivre = false
        },
        postParam(item) {
            console.log(item)
            if (item.length > 0) {
                item.map((t, index) => {
                    if (index == 0) {
                        this.checkList = t.driverNum
                    } else {
                        this.checkList = this.checkList + ',' + t.driverNum
                    }
                })
            } else {
                this.checkList = ''
            }
        },
        getAdminDriver() {
            if (this.btnType == 'add'){
                this.dialogVisibleAdminDrivre = true
                this.$nextTick(() => {
                    this.$refs.adminTable.checkedTable = []
                    this.$refs.adminTable.orgId = this.id
                    this.$refs.adminTable.getDriver()
                    this.$refs.adminTable.$refs.multipleTable.clearSelection();
                    this.$refs.adminTable.$refs.multipleTable.toggleAllSelection();
                })
            } else {
                this.dialogVisibleAdminDrivre = true
                this.$nextTick(() => {
                    this.$refs.adminTable.checkedTable = []
                    this.$refs.adminTable.orgId = this.id
                    this.$refs.adminTable.getDriver()
                    this.$refs.adminTable.getRightData()
                    this.$refs.adminTable.$refs.multipleTable.clearSelection();
                    this.$refs.adminTable.$refs.multipleTable.toggleAllSelection();
                })
            }
        },
        handleAdminDrivreClose() {
            this.dialogVisibleAdminDrivre = false
        },
        AdminSure() {
            this.form.adminList = this.checkAdminList
            this.dialogVisibleAdminDrivre = false
        },
        adminParam(val) {
            console.log(val)
            if (val.length > 0) {
                val.map((n, index) => {
                    if (index == 0) {
                        this.checkAdminList = n.driverNum
                    } else {
                        this.checkAdminList = this.checkAdminList + ',' + n.driverNum
                    }
                })
            } else {
                this.checkAdminList = ''
            }
        },

        deleteTerminal() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'), {
                cancelButtonText: this.$t('common.btn.cancel'),
                confirmButtonText: this.$t('common.btn.confirm'),
                type: 'warning'
            }).then(res => {
                let param = {
                    fingerGroupId: this.selected[0].fingerGroupId
                }
                this.$store.dispatch('DriverFingerprintFile/GET_DELETEFINGERPRINTLIBRARY', param).then(response => {
                    if (response.data.code == 200) {
                        this.getFingerprintLibraryList()
                        this.$message.success(this.$t('common.btn.deleteSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },
        transferTerminal() {
            this.dialogTransferFormVisible = true
            this.TransferForm.fingerGroupId = ''
            this.selected.map(item => {
                if (this.selected.length > 1) {
                    this.TransferForm.fingerGroupId = this.TransferForm.fingerGroupId.concat((item.fingerGroupId + '-' + item.orgName + ','))
                } else {
                    this.TransferForm.fingerGroupId = this.TransferForm.fingerGroupId.concat((item.fingerGroupId + '-' + item.orgName))
                }
            })
        },
        changeClick(val) {
            this.roleId = val.label
        },
        submitTransferForm(TransferFormName) {
            this.$refs[TransferFormName].validate((valid) => {
                if (valid) {
                    let fingerGroupIds = ''
                    this.selected.map((item, index) => {
                        if (index == 0) {
                            fingerGroupIds = item.fingerGroupId
                        } else {
                            fingerGroupIds = fingerGroupIds + ',' + item.fingerGroupId
                        }
                    })
                    let param = {
                        fingerGroupId: fingerGroupIds,
                        orgId: this.roleId,
                    }
                    this.$store.dispatch('DriverFingerprintFile/GET_TRANSFERFINGERPRINTLIBRARY', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.transferSuccess'))
                            this.dialogTransferFormVisible = false;
                            this.getFingerprintLibraryList();
                            this.closeTransfer();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })
                } else {
                    return false;
                }
            });
        },
        cancleTransfer(TransferFormName) {
            this.dialogTransferFormVisible = false;
            this.TransferForm = {
                fingerGroupId: '',
                roleId: ''
            }
        },
        closeTransferDia() {
            this.TransferForm = {
                fingerGroupId: '',
                roleId: ''
            }
            this.dialogTransferFormVisible = false;
        },
        closeOperateDia() {
            this.dialogOperateFormVisible = false
        },
        handleAuthorizeChange() { },
        getNormalList() {
            let param = {
                fingerGroupId: this.fingerGroupId,
                authorizePower: 1
            }
            this.$store.dispatch('DriverFingerprintFile/GET_SELECTPRINTLIBRARYLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.normalList = res.data.data.list
                    }
                }
            }).catch(err => { })
        },
        getAdminList() {
            let param = {
                fingerGroupId: this.fingerGroupId,
                authorizePower: 2
            }
            this.$store.dispatch('DriverFingerprintFile/GET_SELECTPRINTLIBRARYLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.adminList = res.data.data.list
                    }
                }
            }).catch(err => { })
        },
        down() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/uploadFingerWarehouseList?orgId=${this.id}&fingerGroupId=${this.formInline.fingerGroupId}&fingerGroupName=${this.formInline.fingerGroupName}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/uploadFingerWarehouseList?orgId=${this.id}&fingerGroupId=${this.formInline.fingerGroupId}&fingerGroupName=${this.formInline.fingerGroupName}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getFingerprintLibraryList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}